<template>
  <div class="wrapper">
    <div
      class="section page-header header-filter"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-50 md-small-size-66 md-xsmall-size-100 md-medium-size-40 mx-auto mt-5"
          >
              <login-card header-color="orange">
                <h4
                  slot="title"
                  class="card-title"
                >
                  Forgot My Password
                </h4>
                <p
                  slot="description"
                  class="description"
                  v-show="!submitted"
                >
                  Select your Grade and associated ID number as username
                </p>
                <div
                  slot="description"
                  class="description"
                  v-show="submitted"
                >
                  <p class="title icon icon-success">
                    <md-icon style="font-size: 3rem !important;">check_circle</md-icon>
                  <p>
                  <p>
                    Instructions to reset your password has been sent to the e-mail address associated with your account
                  </p>
                </div>
                <md-field
                  slot="inputs"
                  class="md-layout"
                  v-show="!submitted"
                >
                  <md-icon>account_circle</md-icon>
                  <label>Username</label>
                  <md-select
                      id="grade"
                      v-model="grade"
                      name="grade"
                      class="md-layout-item md-size-30"
                  >
                    <md-option value="ae">
                        AE
                    </md-option>
                    <md-option value="aae">
                        AAE
                    </md-option>
                    <md-option value="at">
                        AT
                    </md-option>
                    <md-option value="aet">
                        AET
                    </md-option>
                    <md-option value="aat">
                        AAT
                    </md-option>
                    <md-option value="aaet">
                        AAET
                    </md-option>
                  </md-select>
                  <md-input v-model="firstname" />
                </md-field>
                <md-button
                  slot="footer"
                  class="md-simple"
                  @click="$router.push('login')"
                >&laquo; Back to Login</md-button>
                <md-button
                  slot="footer"
                  class="md-warning md-lg"
                  @click="submitted = true"
                  v-show="!submitted"
                >
                  Submit
                </md-button>
              </login-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LoginCard } from "@/components";
import Mixins from "@/plugins/basicMixins";

export default {
    components: {
        LoginCard
    },
    mixins: [Mixins.HeaderImage],
    bodyClass: "login",
    data() {
        return {
            submitted: false,
            grade: "ae",
            image: require("@/assets/img/hero3.jpg"),
            firstname: null,
            email: null,
            password: null
        };
    }
};
</script>

<style lang="css"></style>
